import React, { FC } from "react"
import { Path, Svg, View } from "@react-pdf/renderer"

export type PdfIcon = {
    fill: string
}
const NorthEast: FC<PdfIcon> = (props) => {
    const { fill } = props;
    return (
        <View style={{height: 20, width: 20}}>
            <Svg height={30} width={30}>
                <Path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" 
                    fill={fill || "currentColor"} // Set fill from props or default to 'currentColor'
                />
            </Svg>
        </View>
    )
}

export default NorthEast;